import React from "react";
import { View } from "react-native";

import { QuestionTitle, Images } from "components";
import { ScreenType } from "consts";

import * as types from "./types";
import { styles } from "./styles";

const screenTypeMap = {
  [ScreenType.CHECK_BOX]: types.CheckBoxQuestion,
  [ScreenType.CONSENT]: types.ConsentQuestion,
  [ScreenType.CONTACT_NUMBER]: types.ContactNumberQuestion,
  [ScreenType.DIVISION]: types.DivisionQuestion,
  [ScreenType.DRILLED_DOWN]: types.DrilledDownQuestion,
  [ScreenType.EMAIL_ADDRESS]: types.EmailAddressQuestion,
  [ScreenType.EMOJI_NPS]: types.EmojiNpsQuestion,
  [ScreenType.ICON]: types.IconQuestion,
  [ScreenType.IMAGE]: types.ImageQuestion,
  [ScreenType.MEDIA]: types.MediaQuestion,
  [ScreenType.LABELLED_IMAGE]: types.LabelledImageQuestion,
  [ScreenType.LIST]: types.ListQuestion,
  [ScreenType.NPS]: types.NpsQuestion,
  [ScreenType.OPEN_ENDED]: types.OpenEndedQuestion,
  [ScreenType.PRODUCTS_LIST]: types.ProductQuestion,
  [ScreenType.STAR]: types.StarQuestion,
  [ScreenType.TEXT_AREA]: types.OpenEndedQuestion,
  [ScreenType.TEXT_INPUT]: types.TextInputQuestion,
  [ScreenType.TILE]: types.TileQuestion,
  [ScreenType.DESCRIPTION]: types.DescriptionQuestion,
  [ScreenType.ASSIGNEE]: types.AssigneeQuestion,
  [ScreenType.MCQS]: types.MultipleQuestion,
  [ScreenType.FEEDBACK_REVIEW]: types.FeedbackReviewQuestion,
};

const Section = props => {
  const { section, response, ...otherProps } = props;
  if (!section) {
    return <></>;
  }
  const sectionTitle = { text: section.title, text_urdu: section.title_urdu };
  return (
    <>
      {section.title?.length && <QuestionTitle question={sectionTitle} />}
      {section.questions.map(question => {
        const Question = screenTypeMap[question.app_screen_type];
        let selectedQuestion = response?.questions[question.virtual_id] || {};
        let selectedOptions = selectedQuestion.options || {};
        let childQuestions = [];

        // Filtering child questions if the question is a is_master_question=true and MCQ MQ screen type.
        // MCQs question is only rendered for master question with app_screen_type='MQ'
        // All childQuestions are passed as props and displayed in table.
        // If question is MQ screen type but is_master_question=false, it is ignored.

        if (question.is_master_question) {
          childQuestions = section.questions.filter(
            q => question.id === q.master_question,
          );
          selectedOptions = childQuestions.map(q => {
            const selectedQuestions = Object.keys(response.questions);
            if (selectedQuestions.includes(String(q.virtual_id))) {
              return {
                virtual_id: q.virtual_id,
                option: response.questions[q.virtual_id].options,
              };
            }
            return undefined;
          });
          selectedOptions = selectedOptions
            .filter(i => i)
            .reduce(
              // eslint-disable-next-line no-sequences
              (r, { virtual_id, option }) => ((r[virtual_id] = option), r),
              {},
            );
        }
        const extraProps = {
          question,
          childQuestions,
          response,
          selectedOptions,
        };

        const imagesAbove =
          question.images?.filter(image => image.position === "A") || [];
        const imagesBelow =
          question.images?.filter(image => image.position === "B") || [];

        return (
          <View style={styles.section} key={question.id}>
            {!!imagesAbove.length && <Images images={imagesAbove} />}
            {question.is_statement_visible &&
              question.app_screen_type !== ScreenType.TILE &&
              question.app_screen_type !== ScreenType.DESCRIPTION &&
              question.app_screen_type !== ScreenType.MCQS && (
                <QuestionTitle question={question} />
              )}
            {!!imagesBelow.length && <Images images={imagesBelow} />}
            {question.app_screen_type !== ScreenType.MCQS && (
              <Question {...otherProps} {...extraProps} />
            )}
            {question.is_master_question && (
              <>
                <QuestionTitle question={question} />
                <Question {...otherProps} {...extraProps} />
              </>
            )}
          </View>
        );
      })}
    </>
  );
};

export default Section;
